import { initialStoreViewsState, STORE_VIEWS_ACTIONS } from './storeViews.types'

/**
 *
 * @param {import('./storeViews.types').StoreViewsSlice} state
 * @param {import('./storeViews.types').StoreViewsAction} action
 * @returns
 */
export function storeViewsReducer(state = initialStoreViewsState, { type, payload }) {
  switch (type) {
    case STORE_VIEWS_ACTIONS.SET_STORE_VIEWS_STATUS:
      return { ...state, status: payload }

    case STORE_VIEWS_ACTIONS.SET_STORE_VIEWS_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case STORE_VIEWS_ACTIONS.SET_STORE_VIEWS_CURRENT:
      return { ...state, current: payload }

    case STORE_VIEWS_ACTIONS.SET_STORE_VIEWS_AVAILABLE:
      return { ...state, available: payload }

    case STORE_VIEWS_ACTIONS.CLEAR_STORE_VIEWS_ERRORS:
      return { ...state, errors: [] }

    case STORE_VIEWS_ACTIONS.CLEAR_STORE_VIEWS_CURRENT:
      return { ...state, current: null }

    case STORE_VIEWS_ACTIONS.CLEAR_STORE_VIEWS_AVAILABLE:
      return { ...state, available: [] }

    default:
      return state
  }
}
